import { toast } from 'react-toastify';
import { LoadingKeys } from '@/constants';
import { loadingStore } from './loading.store';
import { AxiosError } from 'axios';
import { t } from 'i18next';

export const handleApiCallInStore = async (
  loadingKey: LoadingKeys,
  apiCall: () => void,
  errorMessage?: string,
  onFail?: (err: Error) => void
  ) => {
  try {
    loadingStore.getState().setLoading(loadingKey, true);
    await apiCall();
  } catch (error) {
    if (error instanceof AxiosError) {
      const message = error?.response?.data?.message || `${t('serverError')}`;
      toast.error(errorMessage ?? message, {autoClose: 10000});
      onFail?.(error as Error);
    } else if (onFail) {
      onFail?.(error as Error);
    }
  } finally {
    loadingStore.getState().setLoading(loadingKey, false);
  }
};
